import { keymap } from 'prosemirror-keymap';
import { IndentCommand } from '@nimbus-library/features/shared/components/material/input-rich-text/input-rich-text-menu/lists-and-indent-toggle-group/indent-command';
import { RichTextMenuButtonType } from '@nimbus-library/features/shared/components/material/input-rich-text/models/rich-text-menu-button-type.model';

export const InputRichTextIndentPlugin = keymap({
  Tab: (state, dispatch) => {
    IndentCommand(RichTextMenuButtonType.Indent, state, dispatch);
    return true;
  },
  'Shift-Tab': (state, dispatch) => {
    IndentCommand(RichTextMenuButtonType.Outdent, state, dispatch);
    return true;
  },
});
